import {mainServer} from '../../../../variables/config'

export const request_public_insurance = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/publicinsurance/"+id);
  return response.data.data.public_insurance
}
